<script lang="ts">
	import { createEventDispatcher } from 'svelte'

	import ButtonBase from './ButtonBase.svelte'

	const dispatch = createEventDispatcher()

	export let data_test_id = ''
	export let href = ''
	// export let type: 'primary' | 'secondary' | 'danger' | 'tertiary' = 'primary'
	export let type: 'primary' | 'secondary' = 'primary'
	export let preload_data: 'none' | 'off' | 'hover' | 'tap' = 'none'
	export { className as class }
	let className = ''

	export let useClick = false
	export let disabled = false
	export let selected = false
	export let isLast = false

	$: customClass = getCustomClass(selected, isLast)

	function handleClick(event: Event) {
		if (!useClick) return

		event.preventDefault()
		event.stopPropagation()

		if (disabled) return

		dispatch('click', event)
	}

	function getCustomClass(selected: boolean, isLast: boolean) {
		let customClass = ''
		if (selected) {
			customClass += ' !bg-gray-300 !font-bold'
		}
		if (!isLast) {
			customClass += ' mr-2'
		}
		return customClass
	}
</script>

<div class="container_ButtonListHeader">
	<ButtonBase
		class="{className} {customClass}"
		{type}
		{useClick}
		{disabled}
		{data_test_id}
		{preload_data}
		{href}
		{...$$restProps}
		on:click={(e) => handleClick(e)}
		><slot />
	</ButtonBase>
</div>

<style lang="postcss">
	.container_ButtonListHeader :global(.invButton) {
		@apply rounded border text-sm py-2 bg-gray-100 text-gray-500 leading-snug justify-center;
		/* @apply rounded border text-sm py-2 bg-gray-100 text-gray-500 leading-snug w-full  */
		/* @apply rounded border text-sm py-2 bg-gray-100 text-gray-500 leading-snug w-max px-4; */
		/* @apply         border text-sm py-2 bg-gray-100 text-gray-500 leading-snug w-full; */
	}
	.container_ButtonListHeader :global(.invButton:focus) {
		@apply outline-none;
	}
	.container_ButtonListHeader :global(.invButton:hover) {
		@apply border-gray-400;
	}
	/* ------------------------------------------ */
	/* primary button */
	.container_ButtonListHeader :global(.invButton.primary) {
		@apply w-full;
	}
	/* ------------------------------------------ */
	/* secondary button */
	.container_ButtonListHeader :global(.invButton.secondary) {
		@apply w-max px-4;
	}
</style>
